import React from 'react';
import CaseStudySection1 from '../../components/casestudy/casestudysection1';
import CaseStudyAddress from '../../components/casestudy/casestudyaddress';
import CaseStudy2Section3 from '../../components/casestudy/casestudy2section3';
import CaseStudy2Articles from '../../components/casestudy/casestudy2Articles';
import ContactSection from '../../components/home/ContactSection';

const CaseStudyDetailPage = () => {
    return (
        <div className="casestudy-detail-page">
            <CaseStudySection1
                title={<><span className="text-primary">PDF to BIM</span> Conversion Case Study</>}
                breadcrumb={[
                    "Home",
                    "Case Studies",
                    "PDF to BIM Conversion Case Study"
                ]}
            />
            <CaseStudyAddress />
            <CaseStudy2Section3 />
            <CaseStudy2Articles />
            <ContactSection />
        </div>
    );
};

export default CaseStudyDetailPage;
